import axios from "axios";

/**
 * Application Status Management
 * Handles status updates for applications from the company dashboard
 * and withdrawal requests from the user dashboard
 */

class ApplicationStatus {
  constructor() {
    this.statusSelects = document.querySelectorAll(".application-status-select");
    this.withdrawBtns = document.querySelectorAll(".application-withdraw-btn");

    this.events();
  }

  events() {
    this.statusSelects.forEach((select) => {
      select.addEventListener("change", this.handleStatusChange.bind(this));
    });

    this.withdrawBtns.forEach((btn) => {
      btn.addEventListener("click", this.handleWithdraw.bind(this));
    });
  }

  async handleStatusChange(e) {
    const select = e.currentTarget;
    const applicationId = select.dataset.applicationId;
    const newStatus = select.value;
    // Disable select during update
    select.disabled = true;
    select.classList.add("opacity-50");

    try {
      const response = await axios.post(
        gbThemeData.root_url + "/wp-json/all/v1/updateApplicationStatus",
        {
          applicationId: applicationId,
          status: newStatus,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": gbThemeData.nonce,
          },
        },
      );

      if (response.data.success) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error updating application status:", error);

      if (error.response) {
        console.error("Error response:", error.response.data);
      }

      this.showFeedback(select, "error");
      select.disabled = false;
      select.classList.remove("opacity-50");
    }
  }

  async handleWithdraw(e) {
    const btn = e.currentTarget;
    const applicationId = btn.dataset.applicationId;

    // Confirm withdrawal
    if (!confirm("本当にこの応募を辞退しますか？")) {
      return;
    }

    // Disable button during update
    btn.disabled = true;
    btn.classList.add("opacity-50");
    const originalText = btn.textContent;
    btn.textContent = "処理中...";

    try {
      const response = await axios.post(
        gbThemeData.root_url + "/wp-json/all/v1/withdrawApplication",
        {
          applicationId: applicationId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": gbThemeData.nonce,
          },
        },
      );

      if (response.data.success) {
        // Update UI to show withdrawn state
        const row = btn.closest("tr");
        const statusCell = row.querySelector("td:nth-last-child(2)");
        if (statusCell) {
          statusCell.innerHTML =
            '<span class="px-2 py-1 rounded text-xl bg-gray-100 text-gray-800">辞退</span>';
        }

        // Replace button with withdrawn text
        btn.parentElement.innerHTML = '<span class="text-gray-400 text-sm">辞退済み</span>';
      }
    } catch (error) {
      console.error("Error withdrawing application:", error);
      btn.disabled = false;
      btn.classList.remove("opacity-50");
      btn.textContent = originalText;
      this.showFeedback(btn, "error");

      if (error.response) {
        console.error("Error response:", error.response.data);
      }
    }
  }

  showFeedback(element, type) {
    const originalClasses = element.className;

    if (type === "success") {
      element.classList.add("border-green-500", "bg-green-50");
    } else {
      element.classList.add("border-red-500", "bg-red-50");
    }

    setTimeout(() => {
      element.className = originalClasses;
    }, 2000);
  }
}

export default ApplicationStatus;
